import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=9449019a&"
import script from "./Mapping.vue?vue&type=script&lang=ts&"
export * from "./Mapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports